import axios from './http'

export function packageInit(token){
  return axios({
    url: '/api/package_info/package/init',
    method: 'get',
    headers: {
      'authorization': token
    }
  })
}

export function packageInfoQuery(param,token){
  return axios({
    url: '/api/package_info/package/query',
    method: 'post',
    data: param,
    headers: {
      'authorization': token
    }
  })
}

export function activityInit(token){
  return axios({
    url: '/api/package_info/activity/init',
    method: 'get',
    headers: {
      'authorization': token
    }
  })
}

export function parentBrandChang(supplier,parentBrand,token){
  return axios({
    url: '/api/package_info/activity/parentBrandChang/'+supplier+'/'+parentBrand,
    method: 'get',
    headers: {
      'authorization': token
    }
  })
}

export function addPackageSubmit(data,token){
  return axios({
    url: '/api/package_info/package/addPackageSubmit',
    method: 'post',
    data: data,
    headers: {
      'authorization': token
    }
  })
}

export function editPackageSubmit(data,token){
  return axios({
    url: '/api/package_info/package/editPackage',
    method: 'post',
    data: data,
    headers: {
      'authorization': token
    }
  })
}

export function packageTimeRangEdit(data,token){
  return axios({
    url: '/api/package_info/package/packageTimeRangEdit',
    method: 'put',
    data: data,
    headers: {
      'authorization': token
    }
  })
}

export function downloadRuleTemplate(token,param) {
  return axios({
    method: 'post',
    url: '/api/package_info/package/downloadRuleTemplate',
    responseType: 'blob',
    data: param,
    headers: {
      'authorization': token
    }
  })
}


export function uploadRuleTemplate(token, data) {
  return axios({
    method: 'post',
    url: '/api/package_info/package/uploadRuleTemplate',
    headers: {
      'authorization': token,
      'Content-Type': 'multipart/form-data'
    },
    data: data
  })
}


export function getCityAndDistrict(token,param) {
  return axios({
    method: 'POST',
    url: '/api/package_info/package/getCitysAndDistrict',
    headers: {
      'authorization': token
    },
    data: param
  })
}

export function getBrand(token, data) {
  return axios({
    method: 'POST',
    url: '/api/package_info/package/getBrand',
    headers: {
      'authorization': token
    },
    data: data
  })
}

export function countData(token,param,supplierId) {
  return axios({
    method: 'POST',
    url: '/api/package_info/package/countData',
    headers: {
      'authorization': token,
      'supplierId':supplierId
    },
    data: param
  })
}

export function pushPackage(token,data){
  return axios({
    method: 'POST',
    url: '/api/package_info/package/pushPackage',
    headers: {
      'authorization': token
    },
    data: data
  })
}

export function getHistoryTemplate(token, supplierId, packageId) {
  return axios({
    method: 'POST',
    url: '/api/package_info/package/getHistoryTemplate',
    headers: {
      'authorization': token,
      'supplierId': supplierId,
      'packageId': packageId
    }
  })
}

export function useHistoryTemplate(token, supplierId,currentPackageId, historyPackageId, sources) {
  return axios({
    method: 'POST',
    url: '/api/package_info/package/useHistoryTemplate',
    headers: {
      'authorization': token,
      'supplierId': supplierId,
      'currentPackageId': currentPackageId,
      'historyPackageId': historyPackageId,
      'sources': sources
    }
  })
}

export function downloadUnassignedSale(token, data,cancelToken) {
  return axios({
    method: 'POST',
    url: '/api/package_info/package/downloadUnassignedSale',
    responseType: 'blob',
    headers: {
      'authorization': token
    },
    data: data,
    cancelToken
  })
}

export function queryUnassignedSaleCount(token, supplierId) {
  return axios({
    method: 'POST',
    url: '/api/package_info/package/queryUnassignedSaleCount',
    headers: {
      'authorization': token,
      'supplier_id': supplierId
    }
  })
}

export function querySupplierExtraPropList(token, data) {
  return axios({
    method: 'POST',
    url: '/api/package_info/package/querySupplierExtraPropList',
    headers: {
      'authorization': token
    },
    data: data
  })
}


export function downLoadPackageDetail(token, data) {
  return axios({
    method: 'POST',
    url: '/api/package_info/package/downLoadPackageDetail',
    responseType: 'blob',
    headers: {
      'authorization': token
    },
    data: data
  })
}

export function downloadPackageTemplate(token,supplierId) {
  return axios({
    method: 'GET',
    url: '/api/package_info/package/downloadPackageTemplate/' + supplierId,
    responseType: 'blob',
    headers: {
      'authorization': token
    }
  })
}

export function uploadPackageTemplate(token, data) {
  return axios({
    method: 'post',
    url: '/api/package_info/package/uploadPackageTemplate',
    headers: {
      'authorization': token,
      'Content-Type': 'multipart/form-data'
    },
    data: data
  })
}

export function uploadSaleTemplate(token, data) {
  return axios({
    method: 'post',
    url: '/api/package_info/package/uploadSaleTemplate',
    headers: {
      'authorization': token,
      'Content-Type': 'multipart/form-data'
    },
    data: data
  })
}
